import { Component, OnInit, ViewContainerRef } from '@angular/core'
import { NzModalService } from 'ng-zorro-antd/modal'
import { QueryTable } from 'src/app/services/interface/general.model'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NzButtonSize } from 'ng-zorro-antd/button'
import { PermitManagementService } from 'src/app/services/permit-management/permit-management.service'
import { format } from 'date-fns'

@Component({
  selector: 'app-head-approval',
  templateUrl: './head-approval.component.html',
  styleUrls: ['./head-approval.component.scss'],
})
export class HeadApprovalPermitComponent implements OnInit {
  size: NzButtonSize = 'large'
  status = ''

  listOfData: any[] = []

  isLoading: boolean = true
  totalData: number = 0
  pageSize: number = 5
  pageIndex: number = 1

  modeDownload = null
  dateDownload = null

  form: FormGroup
  constructor(
    private modal: NzModalService,
    private permitManagementService: PermitManagementService,
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      keyword: [null, Validators.compose([Validators.required])],
      prefix: ['vendor', Validators.compose([Validators.required])],
      date: [''],
      mode: [''],
    })
  }

  queryTable: QueryTable = {
    sort: { field: null, order: null },
    filters: [],
    pageSize: this.pageSize,
    pageIndex: this.pageIndex - 1,
  }

  listOfColumns = [
    {
      name: 'Actions',
      key: 'actions',
      sortOrder: null,
      sortFn: null,
      listOfFilter: [],
      filterFn: null,
      left: true,
      right: false,
      width: '40px',
    },
    {
      name: 'Nama',
      key: 'employee_name',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Tipe izin',
      key: 'type',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Jumlah izin',
      key: 'total_permit',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Tanggal izin',
      key: 'date',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Posisi',
      key: 'position_name',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
    {
      name: 'Catatan tidak disetujui',
      key: 'notes_approval',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '50px',
    },
  ]

  ngOnInit(): void {
    this.fetchListApprovalHr()
  }

  fetchListApprovalHr() {
    this.isLoading = true
    this.permitManagementService.getListApprovalPermit(this.queryTable, 'WAITING').subscribe(
      (r: any) => {
        this.isLoading = false
        this.listOfData = r.rows
        this.totalData = r.count

        // console.log({ DATAHR: r })
      },
      error => {
        // console.log({ AAA: error })
        this.isLoading = false
      },
    )
  }

  onQueryParamsChange(params): void {
    const { pageSize, pageIndex, sort, filter } = params
    this.queryTable.pageSize = pageSize
    this.queryTable.pageIndex = pageIndex - 1
    const currentSort = sort.find(item => item.value !== null)
    const sortField = (currentSort && currentSort.key) || null
    const sortOrder = (currentSort && currentSort.value) || null

    if (sortField != null && sortOrder != null) {
      this.queryTable.sort = {
        field: sortField,
        order: sortOrder,
      }
    } else {
      this.queryTable.sort = { field: null, order: null }
    }
    this.fetchListApprovalHr()
  }

  search() {
    if (this.form.value.keyword || this.form.value.keyword?.length > 0) {
      this.queryTable.filters = [
        {
          field: this.form.value.prefix,
          keyword: this.form.value.keyword,
        },
      ]
    } else {
      this.queryTable.filters = []
    }
    this.fetchListApprovalHr()
  }

  changePrefix(event) {
    if (event == 'status') {
      this.form.patchValue({ keyword: true })
    } else {
      this.form.patchValue({ keyword: null })
    }
  }

  reset() {
    this.form.reset()
    this.form.patchValue({ prefix: 'name' })
    this.queryTable.sort = null
    this.queryTable.filters = []
    this.listOfColumns.forEach(r => {
      r.sortOrder = null
    })
    this.fetchListApprovalHr()
  }

  trackByName(_: number, item): string {
    return item.name
  }

  handleDownload = () => {
    let dateFormat = format(this.dateDownload, 'yyyy-MM-dd')
    this.permitManagementService
      .exportApprovalPermit(this.modeDownload, dateFormat, 'HEAD')
      .subscribe((r: any) => {
        this.isLoading = false

        window.open(r.link + '?s=download', '_blank')
      }),
      error => {
        this.isLoading = false
      }
  }

  onChange(result: Date): void {
    this.dateDownload = result
  }
  onChangeMode(result) {
    this.modeDownload = result
  }
}
